module.exports = __webpack_public_path__ + "media/images/play-pause-a012413b.png";